import { render, staticRenderFns } from "./ContentMonthGantt.vue?vue&type=template&id=44732f28&"
import script from "./ContentMonthGantt.vue?vue&type=script&lang=js&"
export * from "./ContentMonthGantt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports